import { TbChecks, TbAlertTriangle, TbCircleX, TbClock, TbCircleMinus } from "react-icons/tb";

export const CHECKPOINT_STATUS_CONFIG: Record<string, { label: string; color: string; icon: any }> = {
  pending: { label: "Scheduled", color: "gray.400", icon: TbClock },
  complete: { label: "Good to Go", color: "green.600", icon: TbChecks },
  partial: { label: "Needs a Nudge", color: "orange.500", icon: TbAlertTriangle },
  behind: { label: "Behind Schedule", color: "red.600", icon: TbCircleX },
  failed: { label: "Behind Schedule", color: "red.600", icon: TbCircleX },
  skipped: { label: "Skipped", color: "gray.500", icon: TbCircleMinus },
};

export const DEFAULT_ONBOARDING_DAYS = 90;
